export default __webpack_public_path__ + "static/media/RakshabandanNew3.e04e9883.png";